import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/system';
import React from 'react';

export const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      left: 12,
    },
    '&:after': {
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },

  '& .MuiSwitch-switchBase': {
    color: theme.palette.grey[500],
    '&.Mui-disabled': {
      color: theme.palette.mode === 'dark' ? '#fff' : '#c6c6c6',
      '& + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-checked': {
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.secondary.main,
        opacity: 1,
        border: 0,
      },
    },
    '& + .MuiSwitch-track': {
      backgroundColor: 'inherit',
      opacity: 1,
      border: 1,
      borderStyle: 'solid',
      borderColor: theme.palette.grey[500],
    },
  },
}));

export interface SwitchSchemaProps
  extends Omit<FormControlLabelProps, 'label' | 'control' | 'defaultValue' | 'onChange'> {
  label?: ((checked: unknown) => React.ReactNode) | React.ReactNode;
  onChange?: (checked: boolean) => void;
  required?: boolean;
  error?: boolean;
}
export type Props = SwitchSchemaProps;

const SwitchSchema = React.forwardRef<any, Props>((props: Props, ref) => {
  const {
    labelPlacement = 'start',
    label = '',
    onChange,
    required,
    checked,
    error,
    ...rest
  } = props;

  return (
    <FormControlLabel
      label={
        <InputLabel
          required={required}
          error={error}
          shrink
          style={{
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'unset',
          }}
        >
          {typeof label === 'function' ? label(checked) : label}
        </InputLabel>
      }
      control={<Android12Switch color="primary" inputRef={ref} />}
      labelPlacement={labelPlacement}
      {...rest}
      checked={checked}
      onChange={(_e, checked) => {
        if (onChange) onChange(checked);
      }}
    />
  );
});

export default SwitchSchema;
